import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ArrowLeft } from 'lucide-react';
import Button from './Button';

const BackButton = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.userInfo);

  const handleBack = () => {
    if (user?.role?.includes('seller')) {
      navigate('/seller/profile', { replace: true });
    } else if (user?.role?.includes('brand')) {
      navigate('/brand/profile', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  };

  return (
    <Button onClick={handleBack} variant="primary" className="flex items-center gap-2">
      <ArrowLeft size={16} /> Back
    </Button>
  );
};

export default BackButton;
